/**
 * NOOKNAILS
 * Entfernt dauerhaft den rechten Scroll-Schatten des Focal-Themes.
 *
 * Ändert NICHT:
 * - Header
 * - Produktbilder
 * - Product Section
 * - Slider
 * - Cart Drawer
 * - Sticky Add to Cart
 */

(function () {
  'use strict';

  function disableRightScrollShadow(scrollShadow) {
    if (!scrollShadow || !scrollShadow.shadowRoot) return;

    const shadowRoot = scrollShadow.shadowRoot;

    /*
     * Focal erzeugt den Schatten innerhalb eines Shadow DOM.
     * Deshalb reicht normales theme.css teilweise nicht aus.
     *
     * Wir fügen direkt in das Shadow DOM eine Regel ein,
     * die NUR den rechten Schatten auf 0 setzt.
     */
    if (!shadowRoot.querySelector('[data-nook-remove-right-shadow]')) {
      const style = document.createElement('style');

      style.setAttribute('data-nook-remove-right-shadow', '');

      style.textContent = `
        s {
          --right: 0px !important;
        }
      `;

      shadowRoot.appendChild(style);
    }

    /*
     * Zusätzlich den eigentlichen rechten Gradient transparent machen.
     */
    scrollShadow.style.setProperty(
      '--scroll-shadow-right',
      'linear-gradient(to left, transparent, transparent)',
      'important'
    );

    const shadowLayer = shadowRoot.querySelector('s');

    if (shadowLayer) {
      shadowLayer.style.setProperty('--right', '0px', 'important');
    }
  }

  function disableAllRightScrollShadows() {
    document.querySelectorAll('scroll-shadow').forEach(function (scrollShadow) {
      disableRightScrollShadow(scrollShadow);
    });
  }

  function initializeNookShadowFix() {
    /*
     * Bereits vorhandene Scroll-Shadows sofort korrigieren.
     */
    disableAllRightScrollShadows();

    /*
     * Shopify/Focal kann später neue Sections, Drawers oder
     * Scroll-Shadow Elemente in die Seite einfügen.
     *
     * Deshalb beobachten wir die Seite dauerhaft.
     */
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;

          if (node.matches && node.matches('scroll-shadow')) {
            disableRightScrollShadow(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll('scroll-shadow').forEach(function (scrollShadow) {
              disableRightScrollShadow(scrollShadow);
            });
          }
        });
      });

      disableAllRightScrollShadows();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    /*
     * Sicherheit bei Shopify Section Reloads.
     */
    document.addEventListener('shopify:section:load', function () {
      requestAnimationFrame(disableAllRightScrollShadows);
    });

    document.addEventListener('shopify:section:select', function () {
      requestAnimationFrame(disableAllRightScrollShadows);
    });

    /*
     * Sicherheit nach Resize / Orientation Change.
     */
    window.addEventListener(
      'resize',
      function () {
        requestAnimationFrame(disableAllRightScrollShadows);
      },
      { passive: true }
    );

    window.addEventListener(
      'orientationchange',
      function () {
        setTimeout(disableAllRightScrollShadows, 100);
      },
      { passive: true }
    );

    /*
     * Noch einmal nach vollständigem Seitenladen anwenden.
     */
    window.addEventListener(
      'load',
      function () {
        disableAllRightScrollShadows();

        setTimeout(disableAllRightScrollShadows, 100);
        setTimeout(disableAllRightScrollShadows, 500);
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeNookShadowFix,
      { once: true }
    );
  } else {
    initializeNookShadowFix();
  }
})();